var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsNo = function SvgNnIconFlagsNo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.2 32.2"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1,
    cy: 16.1,
    r: 16,
    fill: "#ff0015",
    stroke: "#bbbcbc",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.9 14H32l-.436-2.08h-13.5V.32a12.5 12.5 0 0 0-2.09-.172zm0 6.24v11.8s1.02-.045 2.09-.172v-11.6h13.6l.42-2.08h-16.1zm-4.16-2.08H.34s.119 1.23.42 2.08H9.7v10.4l2.08.827zm0-6.24V.72l-2.08.75v10.5H.72L.3 14.05h11.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0037a6",
    d: "M32 14H15.9V.1c-1.42.01-3.05.277-4.16.62l-.023 13.3H.317C.104 15.41.17 16.73.34 18.18h11.4v13.3c1.37.349 2.71.535 4.16.576v-13.9H32c.2-1.38.2-2.78 0-4.16z"
  })));
};
export default SvgNnIconFlagsNo;